import React, { Component } from 'react'
import styles from './styles.scss'

import { TimelineMax, TweenMax, Power3 } from 'gsap'
import SplitText from 'utils/gsapPlugins/SplitText.min'

import WallWrapper from './components/wall-wrapper'
import WallWrapperMobile from './components/wall-wrapper-mobile'

import raf from 'src/utils/raf'
import resize from 'src/utils/resize'
import values from 'src/values'
import config from 'src/config'
import components from 'src/utils/components'

export default class Wall extends Component {
  constructor(props) {
    super(props)

    this.state = { wallDesktop: values.viewport.width > config.bp.md }
    this.key = `wall`
  }

  componentDidUpdate() {
    this.addToMenu()
  }

  componentDidMount() {
    this.initTL()
    this.onResize()

    raf.add(this.onRAF)
    resize.add(this.onResize, this.key)
  }

  componentWillUnMount() {
    raf.remove(this.raf)
    resize.remove(this.onResize)
  }

  initTL() {
    this.tlRAF = new TimelineMax({
      paused: true
    }).fromTo(
      this.refs.contentContainer,
      0.7,
      {
        y: 50
      },
      { y: -50, ease: Power3.easeOut },
      0
    )

    this.tlAnimateIn = new TimelineMax({
      paused: true,
      onStart: () => {
        this.tlAnimateInIsPlaying = true
      },
      onComplete: () => {
        this.tlAnimateInIsEnded = true
        this.tlAnimateInIsPlaying = false
      }
    })
      .fromTo(
        this.refs.title,
        1.5,
        {
          y: 30,
          opacity: 0
        },
        { y: 0, opacity: 1, ease: Power3.easeOut },
        0
      )
      .fromTo(
        this.refs.line,
        0.7,
        {
          x: '-100%'
        },
        { x: '0%', ease: Power3.easeOut },
        0
      )
      .fromTo(
        this.refs.content,
        1.7,
        {
          y: 20,
          opacity: 0
        },
        { y: 0, opacity: 1, ease: Power3.easeOut },
        0.2
      )
  }

  resetTL() {
    this.tlAnimateInIsPlaying = false
    this.tlAnimateInIsEnded = false
    this.tlAnimateIn.pause()
    this.tlAnimateIn.progress(0)
  }

  onResize = () => {
    if (!this.refs.component) return

    if (this.state.wallDesktop != values.viewport.width > config.bp.md) {
      this.setState({ wallDesktop: values.viewport.width > config.bp.md })
    }

    if (!this.refs.component) return

    const $component = this.refs.component.getBoundingClientRect()
    this.topComponent = $component.top + values.scroll.currentY
    this.leftComponent = $component.left

    this.hComponent = this.refs.component.offsetHeight
    this.wComponent = this.refs.component.offsetWidth
    setTimeout(this.addToMenu, 1)

    if (values.viewport.width < config.bp.md && !this.tlAnimateIn.progress()) {
      this.tlAnimateIn.progress(100)
      this.tlRAF.progress(50)
    }
  }

  addToMenu = () => {
    const module =
      values.viewport.width < config.bp.md ? 'homeMenuMobile' : 'homeMenu'

    const obj = {
      order: this.props.order,
      legend: this.props.legend,
      top: module === 'homeMenu' ? this.topComponent - 80 : this.topComponent
    }

    components.allComponents[module].addItem(obj)
  }

  onRAF = () => {
    if (!this.refs.component || values.viewport.width < config.bp.md) return

    this.perc =
      (values.scroll.currentY + values.viewport.height - this.topComponent) /
      (values.viewport.height + this.hComponent)

    this.tlRAF && this.perc >= 0 && this.tlRAF.progress(this.perc)

    this.perc >= 0.1 &&
      !this.tlAnimateInIsEnded &&
      !this.tlAnimateInIsPlaying &&
      this.tlAnimateIn.play(0)

    this.perc >= 0.45 &&
      this.perc < 0.6 &&
      components.allComponents.homeMenu.setMenu(this.props.order, true)

    this.perc >= -0.35 &&
      this.perc < 0.45 &&
      components.allComponents.homeMenu.setMenu(this.props.order + 1, true)

    this.perc <= -0.35 && this.resetTL()
  }

  render() {
    return (
      <div ref="component" className="component wall">
        <div className="grid-24">
          <div
            ref="contentContainer"
            className="grid-14 m-grid-10 content-container">
            <div className="line-container">
              <span ref="line" className="line" />
            </div>
            <div className="content">
              <h3 ref="title">{this.props.title}</h3>
              <p
                ref="content"
                dangerouslySetInnerHTML={{ __html: this.props.content }}
              />
            </div>
          </div>
          {this.state.wallDesktop ? (
            <WallWrapper
              ref="wallWrapper"
              items={this.props.data}
              previous={this.props.previous}
              next={this.props.next}
            />
          ) : (
            <WallWrapperMobile
              ref="wallWrapperMobile"
              items={this.props.data}
              cta={this.props.cta}
            />
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/components/wall/index.js